let state = {
  statement: [],
  statementCategories: [],
  filteredStatement: [],
  recentTransactions: [],
  totalTransactionCount: 0

}
export default state



// WEBPACK FOOTER //
// ./src/store/statement/state.js